let data = [
    {
        id: 0,
        title: "Seasonal Fruits",
        imgUrl: "img/fruits1.jpg"
    },
    {
        id: 1,
        title: "Cut Fruits",
        imgUrl: "img/fruits2.jpg"
    },
    {
        id: 2,
        title: "Dry Fruits",
        imgUrl: "img/fruits3.jpg",

    },
    {
        id : 3,
        title : "Exotic Fruits",
        imgUrl: "img/fruits4.jpg"
      },
      {
        id : 4,
        title : "Fresh Fruits",
        imgUrl: "img/fruits5.jpg"
      },
      {
        id : 5,
        title : "Fresh Vegies",
        imgUrl: "img/fruits6.jpg"
      }
]

export default data;



